import { Column } from 'shared/types/models/EditMetrics';

export function getAttributeColumnsIndexes(columns: Column[]): number[] {
  return columns.reduce<number[]>((acc, column, colIndex) =>
    column.kind === 'attribute' ? [...acc, colIndex] : acc, []
  );
}
